import React, { Fragment } from 'react';
import { Benefits } from 'acq-components/lib/composite-components/Benefits/Benefits';
import { FullWidthBackground } from 'acq-components/lib/composite-components/FullWidthBackground/FullWidthBackground';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import { Image } from 'acq-components/lib/base-components/Image/Image';
import { Link } from 'acq-components/lib/base-components/Link/Link';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import svgFetcher from 'acq-components/lib/utils/svgFetcher';
import ThreeUpStyles from 'acq-components/lib/composite-components/Benefits/styles/us-commercial/CorpCategoryBenefits3Up.scss?modules';
import fullBackStyles from 'acq-components/lib/composite-components/FullWidthBackground/styles/intl-commercial/FullWidthBackground.scss?modules';
import LazyScrollMetricTracker from 'src/universal/components/DTM/LazyScrollMetricTracker';
import styles from './__styles__/styles.scss?modules';

const imageConstructor = item => {
  if (item.css) {
    return <div className={styles.numberIcon}>{item.flagText}</div>;
  }
  if (item.imageName) {
    return svgFetcher(item.imageName, 'dls');
  }
  if (item.imageUrl) {
    return <Image src={item.imageUrl} alt={item.imageAlt || ''} />;
  }
};

const createItemsArr = (content, styles) =>
  content.map((item = {}, index) => {
    return {
      styles,
      key: index,
      direction: item.direction || 'vertical',
      className: styles.bulletListItem,
      image: imageConstructor(item),
      children: (
        <div className={styles.wrapper}>
          <div className={styles.titleComponent}>
            <h3 className={styles.header}>
              <Sanitizer safelySetInnerHTML={item.header || ''} />
            </h3>
          </div>
          <div className={styles.inner}>
            <div className={styles.text}>
              <p>
                {(item.desc || []).map((des, i) => {
                  if (des.type === 'inline' && des.link) {
                    return (
                      <Fragment key={i}>
                        <LazyScrollMetricTracker scrollDtm={item.dtm} />
                        <Link
                          href={des.link.url}
                          onClick={() => sendDTMClickEvent(des.link.dtm)}
                          target="_blank"
                        >
                          <Sanitizer safelySetInnerHTML={des.link.title} />
                        </Link>
                        <Sanitizer safelySetInnerHTML={des.link.text} />
                      </Fragment>
                    );
                  }
                  if (des.text) {
                    return <Sanitizer safelySetInnerHTML={des.text} key={i} />;
                  }
                  if (des.link && des.link.dtm) {
                    return (
                      <Link
                        className={styles.phoneNumber}
                        href={des.link.url}
                        onClick={() => sendDTMClickEvent(des.link.dtm)}
                        key={i}
                      >
                        <Sanitizer safelySetInnerHTML={des.link.title} />
                      </Link>
                    );
                  }
                })}
              </p>
            </div>
          </div>
        </div>
      )
    };
  });

const ThreeUp = React.memo(({ content: moduleData, styles = ThreeUpStyles }) => {
  const { header, dtm, content } = moduleData;
  const itemsArr = createItemsArr(content, styles);
  const unHashedStyle = String(styles.benefits || '')
    .split('--')
    .shift();
  const qeId = `three-up_${unHashedStyle}`;

  return (
    <FullWidthBackground styles={fullBackStyles}>
      <LazyScrollMetricTracker scrollDtm={dtm} />
      <Benefits
        title={header}
        titleProps={{
          Component: 'h2',
          className: styles.title
        }}
        className={styles.benefits}
        styles={styles}
        items={itemsArr}
        qeId={qeId}
      />
    </FullWidthBackground>
  );
});

export { ThreeUp };
